import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from 'react-router-dom';

import { RootStoreContext } from '../stores/rootStore';

interface IProps extends RouteProps {
  component: React.ComponentType<RouteComponentProps<any>>;
}

const PrivateRoute: React.FC<IProps> = ({ component: Component, ...rest }) => {
  const rootStore = useContext(RootStoreContext);
  const { isSignIn } = rootStore.clerkStore;
  return (
    <Route
      {...rest}
      render={(props) =>
        isSignIn ? <Component {...props} /> : <Redirect to={'/admin'} />
      }
    />
  );
};

export default observer(PrivateRoute);
